import {
  getNoAudioSourceInfoText,
  isEmptyAudioSourceFeedback,
} from '@modules/feedback/components/AudioType/utils';
import { MusicOffRounded } from '@mui/icons-material';
import { Box, Stack, Typography, alpha } from '@mui/material';
import { Feedback } from 'v2/core/entities/feedback';

interface NoAudioSourceBannerProps {
  feedback: Feedback;
}

export const NoAudioSourceBanner = ({ feedback }: NoAudioSourceBannerProps) => {
  const isEmptySourceFeedback = isEmptyAudioSourceFeedback(feedback);

  if (!isEmptySourceFeedback) {
    return null;
  }

  return (
    <Box
      sx={{
        borderRadius: 1,
        py: 0.5,
        px: 1,
        backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.05),
      }}
    >
      <Stack spacing={1} direction="row" alignItems="center">
        <MusicOffRounded
          fontSize="small"
          sx={{
            color: 'text.secondary',
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {getNoAudioSourceInfoText(feedback.sourceV2)}
        </Typography>
      </Stack>
    </Box>
  );
};
